import React, { FunctionComponent } from 'react';

import { ReplyHidden } from 'reviews2/feed/review-yeti/reply/labels/ReplyLabelHidden';
import { ReplyLive } from 'reviews2/feed/review-yeti/reply/labels/ReplyLabelLive';
import { ReplyPending } from 'reviews2/feed/review-yeti/reply/labels/ReplyLabelPending';
import { ReplyPublished } from 'reviews2/feed/review-yeti/reply/labels/ReplyLabelPublished';
import { ReplyRejected } from 'reviews2/feed/review-yeti/reply/labels/ReplyLabelRejected';
import { ReplySuccess } from 'reviews2/feed/review-yeti/reply/labels/ReplyLabelSuccess';
import { ReplyProps } from 'reviews2/feed/review-yeti/reply/ReviewReply.types';

import 'reviews2/feed/review-yeti/reply/labels/ReplyLabels.scss';

export const ReplyLabels: FunctionComponent<ReplyProps> = ({ reply }) => {
    return (
        <div className="r4e-review-reply-labels">
            <ReplyHidden reply={reply} />
            <ReplyPending reply={reply} />
            <ReplyRejected reply={reply} />
            <ReplySuccess reply={reply} />
            <ReplyLive reply={reply} />
            <ReplyPublished reply={reply} />
        </div>
    );
};
